import { useState } from 'react'
import { toast } from 'react-toastify'

import { axiosInstance } from '../helpers'
import { TenantSharedDocument } from '../types/companyDocument'

export const useDocuments = (apartmentId: number | null | undefined) => {
    const [isLoading, setIsLoading] = useState(false)
    const [documentList, setDocumentList] = useState<TenantSharedDocument[]>([])

    const getDocumentList = async () => {
        if (apartmentId == null) {
            setDocumentList([])
            return []
        }
        setIsLoading(true)
        try {
            const res = await axiosInstance.get<TenantSharedDocument[]>(
                'company/tenant-shared-document/',
                { params: { apartment_id: apartmentId } },
            )
            setDocumentList(res.data)
            setIsLoading(false)
            return res.data
        } catch (e) {
            toast.error('Error loading documents')
            setIsLoading(false)
            return Promise.reject(e)
        }
    }

    const markDocumentAsViewed = async (documentId: number) => {
        if (apartmentId == null) return
        try {
            await axiosInstance.post(
                `company/tenant-shared-document/${documentId}/mark_as_viewed/`,
                null,
                { params: { apartment_id: apartmentId } },
            )
            setDocumentList((prev) =>
                prev.map((doc) =>
                    doc.id === documentId
                        ? { ...doc, tenant_viewed: true }
                        : doc,
                ),
            )
        } catch (e) {
            // Non-blocking for open action
        }
    }

    return {
        isLoading,
        documentList,
        getDocumentList,
        markDocumentAsViewed,
    }
}
